import React, { memo } from "react";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import { Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const mapStyles = [
  {
    elementType: "geometry",
    stylers: [{ color: "#f5f5f5" }],
  },
  {
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#f5f5f5" }],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [{ color: "#bdbdbd" }],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#eeeeee" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }],
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ color: "#e5e5e5" }],
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [{ color: "#eeeeee" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#c9c9c9" }],
  },
  {
    featureType: "water",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
];

const GoogleMapComponent = memo(({ isLoaded, geolocation, setNavigate }) => {
  const stations = useSelector((state) => state.stations.stattionList);

  const mapContStyles = {
    height: "100%", // Adjust height to your preference
    width: "100%",
  };

  const defaultCenter = {
    lat: geolocation?.latitude || 46.8139, // Center on Quebec City
    lng: geolocation?.longitude || -71.2082,
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={mapContStyles}
      zoom={6}
      center={defaultCenter}
      options={{
        styles: mapStyles,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        region: "CA",
        language: "fr",
      }}
    >
      <MarkerF
        position={{ lat: 43.65, lng: -77.85 }}
        icon={{
          path: "M 0 0",
          strokeWeight: 0,
          scale: 0,
        }}
        label={{
          text: "Lac Ontario",
          color: "#9e9e9e",
          fontSize: "13px",
          fontWeight: "500",
        }}
      />
      {stations?.map(
        (location, index) =>
          location?.latitude &&
          location?.longitude && (
            <MarkerF
              key={index}
              position={{
                lat: location.latitude,
                lng: location.longitude,
              }}
              icon={{
                path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
                fillColor: "#004E9C",
                fillOpacity: 1,
                strokeWeight: 0,
                scale: 1.5,
                anchor: new window.google.maps.Point(12, 22), // ✅ added
                scaledSize: new window.google.maps.Size(24, 24), // ✅ added
              }}
              title={location?.customFields?.raisonsociale}
              onClick={() => setNavigate(location)}
            />
          )
      )}
      <MarkerF
        key={78666}
        icon={{
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10, // size of the circle
          fillColor: "#11BAFF",
          fillOpacity: 1,
          strokeColor: "#c7e9f78a",
          strokeWeight: 5,
          anchor: new window.google.maps.Point(0, 0), // 👈 center point
        }}
        position={defaultCenter}
      />
    </GoogleMap>
  ) : (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
});

export default GoogleMapComponent;
